export const FETCH_VAT_RATES = {
  START: 'vatRatesDB/FETCH_START',
  SUCCESS: 'vatRatesDB/FETCH_SUCCESS',
  ERROR: 'vatRatesDB/FETCH_ERROR',
};
